/* eslint-disable */
// GENERATED FILE - DO NOT EDIT
import React, { SVGProps } from "react";

const SvgAdministration = (props: SVGProps<SVGSVGElement>) => (
  <svg width={29.623} viewBox="0 0 29.623 34.591" {...props}>
    <g data-name="Group 21">
      <path
        data-name="Path 121"
        d="M24.736 10.672a1.183 1.183 0 00-1.165-1.181H22.45l-1.536 1.813c0 .488.659 1.022 1.3 2.04 1.277-.013 2.521-.688 2.521-1.936z"
        fill="#ffbd86"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 22">
      <path
        data-name="Path 122"
        d="M8.708 11.606L7.172 9.491H6.053a1.183 1.183 0 00-1.167 1.181v.736c0 1.248 1.244 1.923 2.521 1.936a36.724 36.724 0 011.301-1.738z"
        fill="#fed2a4"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 23">
      <path
        data-name="Path 123"
        d="M15.397 5.106c-1.77-.049-8.522.829-8.225 4.4v2.339a5.416 5.416 0 00.235 1.517 9.582 9.582 0 003.661 4.863 8.233 8.233 0 001.83.967 4.929 4.929 0 003.826 0 8.2 8.2 0 001.83-.967 9.571 9.571 0 003.661-4.863 5.416 5.416 0 00.235-1.517V9.504c-.278-4.447-7.053-4.398-7.053-4.398z"
        fill="#fed2a4"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 24">
      <path
        data-name="Path 124"
        d="M27.963 26.837c-.615-3.519-3.615-5.107-6.68-6.084-1.029 4.5-2.738 8.174-4.9 13.329h11.921c.667 0 .9-.171.79-.8z"
        fill="#f9f9fb"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 25">
      <path
        data-name="Path 125"
        d="M8.339 20.753c-3.063.977-6.064 2.565-6.68 6.084L.53 33.28c-.11.633.123.8.79.8h11.921a55.078 55.078 0 01-4.905-13.329z"
        fill="#f9f9fb"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 26">
      <path
        data-name="Path 126"
        d="M11.068 18.205v1.79l-.627 1.394c0 2.057 2.311 3.744 4.37 3.744s4.884-1.771 4.222-3.721l-.479-1.415v-1.792c-.574.4-6.911.4-7.486 0z"
        fill="#fed2a4"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 27">
      <path
        data-name="Path 127"
        d="M10.058 3.029c-2.652-.237-2.886 2.455-2.886 3.469v2.994c.933-1.509 2.673-2.805 4.015-2.029a19.1 19.1 0 008.824 2.115 21.58 21.58 0 002.44-.087c1.909-.744 2.623-2.54 2.792-4.613.052-.625.067-.723-.456-.423a5.952 5.952 0 01-3.213.846c-.038 0-.077 0-.113-.008a4.81 4.81 0 002.263-4.246c-.052-.317-.085-.237-.379-.131-5.568 1.977-9.8-3.292-13.286 2.111z"
        fill="#3e5564"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 28">
      <path
        data-name="Path 128"
        d="M22.944 5.18c-.729 2.35-3.59 3.059-5.507 3.073a18.565 18.565 0 01-5.814-.552 19.653 19.653 0 008.387 1.877 21.58 21.58 0 002.44-.087c1.909-.744 2.623-2.54 2.792-4.613.052-.625.067-.723-.456-.423a6.569 6.569 0 01-1.842.725z"
        fill="#344b5a"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 29">
      <path
        data-name="Path 129"
        d="M16.379 34.083c2.494-5 2.865-8.295 2.177-14.071A3.744 3.744 0 0111.069 20c-.5 5.713-.3 9.018 2.177 14.083h3.134z"
        fill="#12b05e"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 30">
      <path
        data-name="Path 130"
        d="M19.776 12.351c-.909 3.075-4.74 6.826-8.3 6.128a8.083 8.083 0 001.419.7 4.929 4.929 0 003.826 0 8.2 8.2 0 001.83-.967 9.571 9.571 0 003.661-4.863 5.416 5.416 0 00.235-1.517V9.497a21.576 21.576 0 01-2.44.087v1.256a5.4 5.4 0 01-.231 1.511z"
        fill="#ffbd86"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 31">
      <path
        data-name="Path 131"
        d="M20.984 26.401l-.4-.854a.518.518 0 01.087-.7l.642-.806a1.147 1.147 0 00.235-.965l-.267-2.323c-.925-.3-1.855-.535-2.728-.754a38.1 38.1 0 01-2.177 14.083l4.445-6.7c.279-.423.389-.511.163-.981z"
        fill="#d1d1df"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 32">
      <path
        data-name="Path 132"
        d="M13.245 34.083c-1.79-5.1-2.177-8.4-2.177-14.083-.873.219-1.8.458-2.728.754l-.267 2.323a1.38 1.38 0 00.206.927l.671.844a.519.519 0 01.088.7l-.4.854c-.223.471-.113.558.165.986z"
        fill="#d1d1df"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 33">
      <path
        data-name="Path 133"
        d="M21.283 20.753l.177 1.538c2.3 1.021 4.255 2.594 4.738 5.357l.863 4.938.21 1.2a1.554 1.554 0 01.027.294h1c.667 0 .9-.171.79-.8l-.1-.548-1.031-5.9c-.61-3.514-3.609-5.102-6.674-6.079z"
        fill="#e8edf2"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 34">
      <path
        data-name="Path 134"
        d="M18.55 20zm0 .015l-.008 1.317a19.718 19.718 0 012.913.96l-.177-1.538c-.925-.3-1.855-.535-2.728-.754v.012z"
        fill="#6a5c6b"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 35">
      <path
        data-name="Path 135"
        d="M12.897 19.175a8.239 8.239 0 01-1.83-.967v1.795a5.415 5.415 0 005.776.842c.071-.062.071.065.071.16v2.09a3.875 3.875 0 00.531-.438 3.731 3.731 0 001.109-2.654v-1.79a8.266 8.266 0 01-1.83.965 4.929 4.929 0 01-3.826 0z"
        fill="#ffbd86"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 36">
      <path
        data-name="Path 136"
        d="M16.378 34.082c2.494-5 2.865-8.295 2.177-14.071a3.75 3.75 0 01-1.627 3.071 21.011 21.011 0 01-2.534 11h1.984z"
        fill="#03984b"
        fillRule="evenodd"
      />
    </g>
    <g data-name="Group 37">
      <path
        data-name="Path 137"
        d="M12.472 12.693a.507.507 0 00-.011-.716 1.688 1.688 0 00-2.33 0 .507.507 0 00.7.729.667.667 0 01.92 0 .507.507 0 00.721-.013z"
      />
      <path
        data-name="Path 138"
        d="M17.5 12.846a.5.5 0 00.353-.143.664.664 0 01.917 0 .507.507 0 00.706-.727 1.684 1.684 0 00-2.328 0 .507.507 0 00.353.87z"
      />
      <path
        data-name="Path 139"
        d="M14.804 17.024a2.157 2.157 0 001.535-.636.507.507 0 10-.717-.716 1.157 1.157 0 01-1.637 0 .507.507 0 10-.717.716 2.156 2.156 0 001.536.636z"
      />
      <path
        data-name="Path 140"
        d="M17.407 7.284a.517.517 0 00.06 0 .507.507 0 00.059-1.01 10.006 10.006 0 01-5.35-2.487.507.507 0 10-.732.7 10.985 10.985 0 005.963 2.797z"
      />
      <path
        data-name="Path 141"
        d="M29.589 33.193l-.7-4.021a.508.508 0 10-1 .175l.7 4.02a.176.176 0 01-.167.205h-3.558v-2.143a.521.521 0 00-.491-.528.507.507 0 00-.522.507v2.169h-6.53l4-6.019a1.164 1.164 0 00.13-1.372s-.434-.923-.441-.942c.01-.015.7-.876.7-.876A1.638 1.638 0 0022.052 23l-.175-1.519c2.615.933 5.062 2.438 5.587 5.443a.507.507 0 00.7.377.519.519 0 00.292-.57c-.851-4.8-5.863-6.23-9.4-7.128v-1.136a10.1 10.1 0 003.529-4.636 2.623 2.623 0 002.653-2.422v-.736a1.689 1.689 0 00-1.172-1.61 6.189 6.189 0 001.676-4.141v-.026c.037-.45.067-.806-.265-1.017a.9.9 0 00-.951.139 6.079 6.079 0 01-1.6.646 5 5 0 001.29-3.7.733.733 0 00-.321-.574.668.668 0 00-.615.01c-.03.012-.065.027-.107.041a10.579 10.579 0 01-6.044-.027 10.446 10.446 0 00-3.908-.332 5.177 5.177 0 00-3.425 2.426 2.776 2.776 0 00-1.987.7A4.559 4.559 0 006.665 6.5v2.485h-.612a1.682 1.682 0 00-1.674 1.687v.736a2.623 2.623 0 002.65 2.422 10.108 10.108 0 003.53 4.638V19.6c-3.538.9-8.557 2.329-9.4 7.147l-1.13 6.447a1.221 1.221 0 00.188 1.022 1.361 1.361 0 001.1.375h26.982a1.362 1.362 0 001.1-.375 1.221 1.221 0 00.187-1.023zm-24.2-21.785v-.736a.676.676 0 01.66-.674h.612v1.83a5.421 5.421 0 00.083.922v.01c-.744-.174-1.357-.633-1.357-1.351zm15.424 9.724l.23 2c0 .013 0 .026.006.039a.623.623 0 01-.116.532l-.018.021-.637.8a1 1 0 00-.154 1.238s.466 1.01.47 1.03c-.018.041-2.688 4.065-2.688 4.065a37.63 37.63 0 001.149-10.21c.569.146 1.161.3 1.757.484zM18.048 20a3.237 3.237 0 01-6.474 0v-.88a8.345 8.345 0 001.147.53 5.43 5.43 0 004.179 0 8.337 8.337 0 001.148-.531zm6.181-9.328v.736c0 .718-.613 1.177-1.357 1.351v-.022a5.415 5.415 0 00.081-.909V10h.614a.675.675 0 01.658.674zM7.679 6.5a3.7 3.7 0 01.815-2.544 1.884 1.884 0 011.52-.42.509.509 0 00.471-.23c1.844-2.859 3.77-2.457 6.444-1.9a11.826 11.826 0 006.317.08 4.513 4.513 0 01-1.937 3.3 10.3 10.3 0 01-4.14-1.086.507.507 0 00-.509.876 10.3 10.3 0 003.284 1.074c.546.091 1.625.158 1.629.158a10.708 10.708 0 001.519-.143 6.957 6.957 0 001.623-.594c-.215 2.066-1 3.35-2.381 3.921h-.021c-3 .27-7.6-.084-10.873-1.971a2.219 2.219 0 00-1.124-.3 3.105 3.105 0 00-1.544.456 5.353 5.353 0 00-1.094.856V6.5zm.214 6.7a4.908 4.908 0 01-.214-1.374V9.639c.857-1.312 2.277-2.3 3.255-1.737a19.954 19.954 0 009.539 2.186c.515 0 1.008-.017 1.471-.047v1.788a4.909 4.909 0 01-.215 1.371 9.088 9.088 0 01-5.182 5.5 4.428 4.428 0 01-3.473 0 7.715 7.715 0 01-1.718-.908A9.1 9.1 0 017.893 13.2zM5.771 33.577v-2.148a.521.521 0 00-.491-.528.507.507 0 00-.522.507v2.169h-3.56a.176.176 0 01-.166-.2l1.127-6.443c.526-3 2.973-4.509 5.587-5.443l-.177 1.537a1.773 1.773 0 00.427 1.444s.612.765.622.781c-.007.019-.44.94-.44.94a1.16 1.16 0 00.13 1.376l3.992 6.016zm9.04 0h-1.206a34.968 34.968 0 01-1.594-6.227.507.507 0 00-1 .153 31.711 31.711 0 00.7 3.356s-2.669-4.023-2.688-4.064c0-.02.472-1.032.472-1.032a1.006 1.006 0 00-.157-1.238l-.559-.7-.018-.021a.758.758 0 01-.187-.667l.23-2c.6-.181 1.189-.339 1.757-.485.01 1.831.067 3.266.179 4.584a.507.507 0 00.5.464h.044a.507.507 0 00.462-.548c-.062-.729-.106-1.5-.135-2.35a4.243 4.243 0 006.393 0 33.5 33.5 0 01-1.991 10.782z"
      />
    </g>
  </svg>
);

SvgAdministration.defaultProps = {};
export default SvgAdministration;
/* eslint-enable */
